var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{attrs:{"shadow":"always"}},[_c('el-page-header',{attrs:{"title":"","content":_vm.title},on:{"back":_vm.back}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }